import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const VariablesFieldContainer = styled(Box)({
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	width: "100%",
});
